/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Lpinsights_Subtitle2Inputs */

const en_coinvestments_lpinsights_subtitle2 = /** @type {(inputs: Coinvestments_Lpinsights_Subtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your co-investment insights`)
};

/**
* | output |
* | --- |
* | "Your co-investment insights" |
*
* @param {Coinvestments_Lpinsights_Subtitle2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_lpinsights_subtitle2 = /** @type {((inputs?: Coinvestments_Lpinsights_Subtitle2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Lpinsights_Subtitle2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_lpinsights_subtitle2(inputs)
});
export { coinvestments_lpinsights_subtitle2 as "coInvestments_lpInsights_subtitle" }